/* istanbul ignore file */
// libs
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, SxProps, Theme } from '@mui/material';

export enum LoaderSize {
  Default = '40px',
  Medium = '24px',
  Small = '17px',
  ExtraSmall = '14px',
}

interface LoadingProps {
  sx?: SxProps<Theme>;
  size?: LoaderSize | string;
  hasBackground?: boolean;
  hasPositionFixed?: boolean;
  isInitialPosition?: boolean;
}

const Loading = ({
  sx,
  size = LoaderSize.Default,
  hasBackground = false,
  hasPositionFixed = false,
  isInitialPosition = false,
}: LoadingProps) => (
  <Box
    data-testid="testid-loader"
    className="loading"
    sx={[
      {
        position: isInitialPosition ? 'initial' : hasPositionFixed ? 'fixed' : 'absolute',
        inset: isInitialPosition ? 'auto' : 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 1,
        backgroundColor: hasBackground ? 'common.loadingOverlay' : 'transparent',
        transition: 'opacity 0.2s',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <CircularProgress size={size} />
  </Box>
);

export default Loading;
